export const maskingName = (input) => {
  if (input) return input.replace(input.slice(1, input.length - 1), "*");
};
export const maskingPhoneNumber = (input) => {
  if (input) return input.replace(input.split("-")[1], "****");
};
